"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Yup = _interopRequireWildcard(require("yup"));

var _isValidPhoneNumber = _interopRequireDefault(require("@zipwhip/zipkit/dist/utils/is-valid-phone-number"));

var _constants = require("../../constants");

var _Yup$object$shape;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // const regexEINNumber = /^[1-9]\d?-\d{7}$/;


var REGEX_ADDRESS = /^[^!@$%^&*(){}:"<>;'_|]+$/;
var REGEX_US_ZIP_CODE_ONLY_NUMBERS = /^[0-9-]+$/;
var REGEX_US_ZIP_CODE_FORMAT = /^\d{5}(?:[-\s]\d{4})?$/;
var REGEX_CANADA_POSTAL_CODE_FORMAT = /^[0-9A-Za-z]{3}\s[0-9A-Za-z]{3}$/;
var DLCSchema = Yup.object().shape((_Yup$object$shape = {}, _defineProperty(_Yup$object$shape, _constants.BUSINESS_NAME_LEGAL, Yup.string().required('Legal Business Name is required. Characters limit: 100.').max(100)), _defineProperty(_Yup$object$shape, _constants.BUSINESS_NAME_DISPLAY, Yup.string().required('Business Name is required. Characters limit: 100.').max(100)), _defineProperty(_Yup$object$shape, _constants.BUSINESS_TYPE, Yup.string().required('Business Type is required')), _defineProperty(_Yup$object$shape, _constants.BUSINESS_VERTICAL, Yup.string().required('Industry or Vertical is required')), _defineProperty(_Yup$object$shape, _constants.TAX_ID, Yup.string().when(_constants.BUSINESS_TYPE, {
  is: _constants.BUSINESS_TYPE_SOLE_PROP,
  then: Yup.string().notRequired(),
  otherwise: Yup.string().trim().max(12).required('Tax ID is required. Characters limit: 12.')
})), _defineProperty(_Yup$object$shape, _constants.NO_TAX_ID_CONSENT, Yup.boolean().when(_constants.BUSINESS_TYPE, {
  is: _constants.BUSINESS_TYPE_SOLE_PROP,
  then: Yup.bool().oneOf([true], 'Field is required')
})), _defineProperty(_Yup$object$shape, _constants.STOCK_EXCHANGE, Yup.string().nullable().when(_constants.BUSINESS_TYPE, {
  is: _constants.BUSINESS_TYPE_PUBLIC,
  then: Yup.string().required('Stock Exchange is required.')
})), _defineProperty(_Yup$object$shape, _constants.STOCK_SYMBOL, Yup.string().max(20).when(_constants.BUSINESS_TYPE, {
  is: _constants.BUSINESS_TYPE_PUBLIC,
  then: Yup.string().trim().required('Stock Symbol is required. Characters limit: 20.')
})), _defineProperty(_Yup$object$shape, _constants.BRAND_WEBSITE, Yup.string().when(_constants.BUSINESS_TYPE, {
  is: _constants.BUSINESS_TYPE_PUBLIC,
  then: Yup.string().required('Website is required')
})), _defineProperty(_Yup$object$shape, _constants.ADDRESS_STATE, Yup.string().required('State is required')), _defineProperty(_Yup$object$shape, _constants.ADDRESS_CITY, Yup.string().required('City is required').max(100).matches(REGEX_ADDRESS, {
  message: 'Only the following special characters are allowed: . , - #. Characters limit: 100.',
  excludeEmptyString: true
})), _defineProperty(_Yup$object$shape, _constants.ADDRESS_STREET, Yup.string().required('Address is required').max(100).matches(REGEX_ADDRESS, {
  message: 'Only the following special characters are allowed: . , - #. Characters limit: 100',
  excludeEmptyString: true
})), _defineProperty(_Yup$object$shape, _constants.ADDRESS_COUNTRY_ID, Yup.string().required('Country is required')), _defineProperty(_Yup$object$shape, _constants.ADDRESS_POSTAL_CODE, Yup.string().max(10).when(_constants.ADDRESS_COUNTRY_ID, {
  is: 'US',
  then: Yup.string().trim().required('Zip Code is required.').matches(REGEX_US_ZIP_CODE_ONLY_NUMBERS, {
    message: 'No letters or special characters allowed. Characters limit: 10.',
    excludeEmptyString: true
  }).matches(REGEX_US_ZIP_CODE_FORMAT, {
    message: 'Must be a well formed postal code (e.g. 98126 or 85297-2176). Characters limit: 10.',
    excludeEmptyString: true
  }),
  otherwise: Yup.string().trim().required('Postal Code is required.').matches(REGEX_CANADA_POSTAL_CODE_FORMAT, {
    message: 'Must be a well formed postal code (e.g. M4S 2N3). Characters limit: 10.'
  }).length(7, 'Must be a well formed postal code (e.g. M4S 2N3). Characters limit: 10.')
})), _defineProperty(_Yup$object$shape, _constants.CONTACT_PHONE, Yup.string().required('Phone is required').when(_constants.ADDRESS_COUNTRY_ID, {
  is: 'US',
  then: Yup.string().trim().test('phone', 'Invalid phone number.', function (value) {
    return (0, _isValidPhoneNumber.default)(value, 'US');
  }),
  otherwise: Yup.string().trim().test('phone', 'Invalid phone number.', function (value) {
    return (0, _isValidPhoneNumber.default)(value, 'CA');
  })
})), _defineProperty(_Yup$object$shape, _constants.CONTACT_NAME, Yup.string().trim().required('Contact Name is required')), _defineProperty(_Yup$object$shape, _constants.CONTACT_EMAIL, Yup.string().trim().required('Email is required').email('Invalid email.')), _Yup$object$shape));
var _default = DLCSchema;
exports.default = _default;